<template>
  <div class="content">
    <div class="main-title">
      <p>{{ $t('lang.Agent Management') }}</p>
    </div>
    <div style="margin-bottom: 40px;"></div>
    <el-form
      :inline="true"
      :model="form"
      class="demo-form-inline"
    >
      <el-form-item :label="$t('lang.Agent/Store')">
        <el-input v-model="form.unitName" :placeholder="$t('lang.Please select an organization')" maxlength="50"
                  clearable/>
      </el-form-item>
      <el-form-item :label="$t('lang.Organization number')">
        <el-input v-model="form.unitNo" :placeholder="$t('lang.Please enter the organization number')" maxlength="50"
                  clearable/>
      </el-form-item>
      <el-form-item :label="$t('lang.Associated account')">
        <el-input @keyup.native="form.accountNo = form.accountNo.replace(/[^\w\.\/]/ig,'')"
                  v-model="form.accountNo" :placeholder="$t('lang.Please enter the associated account')" maxlength="50"
                  clearable/>
      </el-form-item>
      <el-form-item :label="$t('lang.Character')">
        <el-select v-model="form.role" :placeholder="$t('lang.please choose Character')" clearable>
          <el-option v-for="item in ROLE" :key="item.label" :label="$t('lang.'+item.label)" :value="item.value"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onsearch">{{ $t('lang.Inquire') }}</el-button>
        <el-button type="primary" @click="handleAdd(3)">{{ $t('lang.Add agent') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="recordList"
      style="width: 100%;margin-bottom: 20px;"
      class="table-custom"
    >
      <!-- :header-row-style="headerStyle" -->
      <!-- :tree-props="{ children: 'subMenuList', hasChildren: 'true' }" -->
      <el-table-column prop="unitNo" :label="$t('lang.Organization number')" width="200"></el-table-column>
      <el-table-column prop="name" :label="$t('lang.Agent/Store name')" width="200"></el-table-column>
      <el-table-column prop="location" :label="$t('lang.Area')" width="200"></el-table-column>
      <el-table-column prop="role" :label="$t('lang.Character')" width="150">
        <template slot-scope="{row}">{{ $t('lang.' + $changeObj(ROLE)[row.role]) }}</template>
      </el-table-column>
      <el-table-column prop="agentName" :label="$t('lang.Affiliated agent')" width="200"></el-table-column>
      <el-table-column prop="accountNo" :label="$t('lang.Associated account')" width="200"></el-table-column>
      <el-table-column prop="createTime" :label="$t('lang.Setup time')" width="200">
        <template slot-scope="{row}">
          <div>{{ $changeTime.showTime(row.createTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.Operating')" width="280" fixed="right">
        <template slot-scope="{row}">
          <el-button @click="handleAdd(0,row)" type="primary" size="mini">{{ $t('lang.Edit') }}</el-button>
          <el-button @click="handleAdd(4,row)" type="primary" size="mini">{{ $t('lang.Delete') }}</el-button>
          <el-button v-if="+row.role === 1" @click="handleAdd(2,row)" type="primary" size="mini">
            {{ $t('lang.New store') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="dfcc">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="form.beginIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="100"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 弹窗 -->
    <el-dialog
      :visible.sync="dialogTableVisible"
      width="500px"
      :show-close="true"
    >
      <!-- 标题 -->
      <div slot="title">
        <p class="h3" v-if="+type === 4">{{ $t('lang.Prompt') }}</p>
        <el-breadcrumb v-else-if="+type !== 4" separator-class="el-icon-arrow-right ">
          <el-breadcrumb-item class="ftb">{{ $t('lang.Agent Management') }}</el-breadcrumb-item>
          <el-breadcrumb-item class="ft18">{{ titleObj[type] }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div v-if="+type === 2 || +type === 1">
        <!-- 新增门店 -->
        <el-form ref="addform" :model="addform" :rules="addRules" class="newStore" label-width="160px">
          <el-form-item :label="$t('lang.Store name')" prop="name" key="addformShopName">
            <el-input
              clearable
              maxlength="50"
              v-model="addform.name"
              :placeholder="$t('lang.Please enter the store name')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.Store area')">
            <el-input
              clearable
              maxlength="300"
              v-model="addform.description"
              :placeholder="$t('lang.Agent area')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.Store address')">
            <el-input
              clearable
              maxlength="50"
              v-model="addform.location"
              :placeholder="$t('lang.Please enter the store address')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.Associated account')" prop="accountNo">
            <el-input
              clearable
              v-model="addform.accountNo"
              :placeholder="$t('lang.Please enter the associated account')"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="dfcc">
          <el-button @click="dialogTableVisible = false">{{ $t('lang.Cancel') }}</el-button>
          <el-button type="primary" @click="searchBtn(2,'addform')">{{ $t('lang.Confirm') }}</el-button>
        </div>
      </div>
      <!-- 新增代理商 -->
      <div v-else-if="+type === 3 || +type === 0">
        <el-form ref="addform" :model="addform" :rules="addRules" class="addForm" label-width="160px">
          <el-form-item :label="$t('lang.Agent name')" prop="name" key="addformname">
            <el-input
              clearable
              maxlength="50"
              v-model="addform.name"
              :placeholder="$t('lang.Please enter the agent name')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.Agent area')">
            <el-input
              clearable
              maxlength="300"
              v-model="addform.description"
              :placeholder="$t('lang.Agent area')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.Agent address')">
            <el-input
              clearable
              maxlength="50"
              v-model="addform.location"
              :placeholder="$t('lang.Please enter the agent address')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.Associated account')" prop="accountNo">
            <el-input
              clearable
              maxlength="50"
              @keyup.native="addform.accountNo = addform.accountNo.replace(/[^\w\.\/]/ig,'')"
              v-model="addform.accountNo"
              :placeholder="$t('lang.Please enter the associated account')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <template slot-scope="{row}">
              <div class="">
                <el-button @click="dialogTableVisible = false">{{ $t('lang.Cancel') }}</el-button>
                <el-button type="primary" @click="searchBtn(3,'addform')">{{ $t('lang.Confirm') }}</el-button>
              </div>
            </template>
          </el-form-item>
        </el-form>
      </div>
      <!-- 删除 -->
      <div v-else-if="+type === 4">
        <p class="mb20 dfcc">{{ $t('lang.Whether confirm to delete this agent/stores') }}</p>
        <div class="dfe">
          <el-button type="primary" @click="searchBtn(4,null)">{{ $t('lang.Confirm') }}</el-button>
        </div>
      </div>


    </el-dialog>
  </div>
</template>

<script>
import {ROLE} from '@/utils/constant';
import {queryUnit, createOrUpdateUnit, deleteAgentAndShopUnit} from '@/api/agent';

export default {
  data() {
    return {
      searchBtnFlag: true,
      ROLE,
      typeStatus: '',
      newStoreRules: {
        val1: {required: true, message: this.$t('lang.account cannot be empty'), trigger: 'blur'},
      },
      // 新增代理商、门店
      addRules: {
        name: {required: true, message: this.$t('lang.The agent name cannot be empty'), trigger: 'blur'},
        accountNo: {required: true, message: this.$t('lang.Associated account cannot be empty'), trigger: 'blur'},
      },
      addform: {
        parentUnitNo: '',//上级代理商
        unitNo: '',
        unitName: '',
        accountNo: '',
        role: '',//门店/代理商
        description: [],
        location: '',
        name: ""
      },
      titleObj: {
        0: this.$t('lang.Edit agent'),//代理商
        1: this.$t('lang.Edit store'),//门店
        2: this.$t('lang.New store'),//门店
        3: this.$t('lang.Add agent'),//代理商
        4: this.$t('lang.Prompt')//删除
      },
      type: 4,
      dialogTableVisible: false,
      recordList: [],
      form: {
        unitNo: '',
        unitName: '',
        accountNo: '',
        role: '',
      },
      beginIndex: 1,
      pageSize: 10,
      total: 0,
      rowData: {},
    }
  },
  mounted() {
    this.onsearch();
    this.agentDel = this.$route.query.agentDel;
  },
  methods: {
    handleCurrentChange(page) {
      this.beginIndex = page;
      this.queryUnit();
    },
    handleSizeChange(pagesize) {
      this.pageSize = pagesize;
    },
    // 编辑
    // handleEdit(row){
    //   // 判断是代理商还是门店
    //   // this.typeStatus = 'add';
    //   this.typeStatus = 'edit';
    // },
    onsearch() {
      this.beginIndex = 1;
      this.queryUnit();
    },
    // 查询
    async queryUnit() {
      try {
        const params = {
          ...this.form,
          beginIndex: this.beginIndex - 1,
          pageSize: this.pageSize
        };
        const res = await queryUnit(params);
        console.log(res, '列表');
        this.recordList = res.ldata;
        this.total = res.mdata.total;

      } catch (e) {
        console.log(e, 'e');
      }
    },
    // 新增代理商，新建门店，启动弹窗
    handleAdd(type, row) {

      this.rowData = row;
      console.log(row, 'row');
      // 点编辑，type=0,再根据role判断是编辑门店还是编辑代理商
      if (type === 0 && row && row.role === 1) {//编辑代理商
        this.addform = {...row}
      }
      if (type === 0 && row && row.role === 2) {//编辑门店
        type = 1;
        this.addform = {...row}
      }

      if (+type === 2) {
        // 新建门店
        this.addform = {
          parentUnitNo: '',
          unitNo: '',
          unitName: '',
          accountNo: '',
          role: 2,
          description: '',
          location: '',
          name: ""
        }

      } else if (+type === 3) {
        // 新增代理商
        this.addform = {
          parentUnitNo: '',
          unitNo: '',
          unitName: '',
          accountNo: '',
          role: 1,
          description: '',
          location: '',
          name: "",
        }

      } else if (+type === 4) {
        // 删除提示

      }
      this.type = type;
      console.log(type, 'type');
      this.dialogTableVisible = true;
    },
    // 确认按钮提交
    async searchBtn(type, formName) {
      if (!this.searchBtnFlag) {
        return;
      }
      this.searchBtnFlag = false;
      console.log(type, 'type');
      let params = {}
      let flag = true;
      //  新建代理商/门店:3/2  /编辑代理商/门店：0/1
      if (+type <= 3) {
        console.log(type, 'type');
        // 新增代理商
        this.$refs[formName].validate(async (valid) => {
          if (!valid) {
            flag = false;
            return;
          }
          params = {...this.addform};
          // 如果是数组就处理，是字符串就过
          if (typeof params.description == 'object') {//如果新建编辑代理商/门店，选了地区
            params.description = params.description.join(',');
          }
          if (type == 1 || type == 2) {//新建/编辑门店
            params.parentUnitNo = this.rowData.unitNo;
          }
          console.log(params)
          const res = await createOrUpdateUnit(params);
          if (res.result === 1) {
            this.$message.success(this.$t('lang.Successful'));
            this.$store.dispatch('queryUnitTree', {isContainRootUnit: 1});
          }
          this.dialogTableVisible = false;
        });

      } else if (+type === 4) {
        // 删除
        params = {
          unitMemberNo: this.rowData.unitMemberNo
        }
        const res = await deleteAgentAndShopUnit(params);
        if (res.result === 1) {
          this.$store.dispatch('queryUnitTree', {isContainRootUnit: 1});
        }
        this.dialogTableVisible = false;
      }
      if (flag) {
        // this.$message.success();
        this.dialogTableVisible = false;
        setTimeout(() => {
          this.onsearch();
        }, 300);
      }
      setTimeout(() => {
        this.searchBtnFlag = true;
      }, 1000);


    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/orderMgmt/rechargeOrderMgmt.vue